// extracted by css-extract-rspack-plugin
export default {"headerContainer":"PropertiesBreadcrumbsPageHeader-module__headerContainer__UfJagim"};